module.exports = __webpack_public_path__ + "assets/img/es-5c8023c7.png";